export default __webpack_public_path__ + "static/media/262.e5bd9035.jpg";